import React from 'react';
import { Field, Formik } from 'formik';
import { FormSelect } from '../forms/elements'; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';

var FilterAccordionSelect = function FilterAccordionSelect(_ref) {
  var categories = _ref.categories,
      _changeHandler = _ref.changeHandler,
      value = _ref.value;
  return /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      faqFilter: "all"
    }
  }, function (props) {
    return /*#__PURE__*/React.createElement(Field, {
      name: "faqFilter",
      label: "Filter FAQs",
      component: FormSelect,
      options: categories,
      id: "faq-filter",
      value: value,
      changeHandler: function changeHandler(e) {
        _changeHandler.call(this, e);

        var data = {
          gtm: {
            uniqueEventId: '28',
            elementId: 'faq-filter',
            elementText: e.target.value
          },
          event: 'gtm.click'
        };
        gaTracker(data);
      }
    });
  });
};

export default FilterAccordionSelect;